var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 46,
    viewBox: "0 0 196 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1041 32.2213C14.1041 32.2213 20.7712 36.6661 27.4743 31.9345C27.4743 31.9345 25.0368 27.3105 23.2087 26.8445C23.2087 26.8445 16.6849 30.6082 9.30078 24.2278C9.30078 24.2636 11.8458 30.429 14.1041 32.2213Z",
    fill: "url(#paint0_linear_446_514)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.981362 11.8207C0.981362 11.8207 -0.0222722 23.7213 14.1008 32.2167C14.1008 32.2167 6.46572 21.8932 9.6201 15.0109C9.65594 15.0109 5.6054 11.2472 0.981362 11.8207Z",
    fill: "#73314F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.992 45.9342C131.992 45.9342 135.82 46.6573 141.519 42.5317C141.519 42.5317 141.859 38.9589 141.221 37.2151C140.541 35.4713 139.35 32.6217 138.372 33.0044C137.394 33.4298 134.161 35.1736 130.971 35.5989C127.781 36.0242 130.801 38.4486 130.376 41.2557C129.95 44.0628 130.163 45.9342 131.992 45.9342Z",
    fill: "url(#paint1_linear_446_514)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9404 39.4029C61.9404 39.4029 66.9489 40.3489 74.4059 34.9509C74.4059 34.9509 74.8511 30.2764 74.0164 27.9947C73.126 25.7131 71.5678 21.9846 70.2878 22.4854C69.0079 23.0419 64.7785 25.3235 60.6049 25.88C56.4312 26.4365 60.3823 29.6086 59.8258 33.2814C59.325 36.9543 59.5475 39.4029 61.9404 39.4029Z",
    fill: "#4F7D7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0351 10.0828C85.0351 10.0828 87.3029 8.6969 88.3109 4.00371C88.3109 4.00371 86.862 2.01935 85.728 1.45239C84.5941 0.885426 82.6728 -0.0280248 82.3578 0.633431C82.0428 1.29489 81.2239 3.65723 79.8065 5.35812C78.3891 7.0275 81.0349 6.90152 82.1058 8.47642C83.1452 10.0828 84.1217 10.9332 85.0351 10.0828Z",
    fill: "#4F7D7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.822 15.2758C116.822 15.2758 118.16 13.9164 118.028 10.4961C118.028 10.4961 116.669 9.37786 115.792 9.18053C114.915 8.9832 113.424 8.67625 113.314 9.20246C113.205 9.70674 113.051 11.5046 112.371 12.9079C111.692 14.3111 113.49 13.763 114.498 14.6838C115.529 15.6047 116.34 16.0213 116.822 15.2758Z",
    fill: "#73314F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.08 31.155C195.08 31.155 196.142 27.1983 192.282 20.9255C192.282 20.9255 188.566 20.25 186.684 20.829C184.803 21.3598 181.714 22.4213 182.1 23.4829C182.438 24.5444 184.03 28.0668 184.272 31.3963C184.465 34.7257 187.215 31.8305 190.11 32.4578C192.957 33.0851 194.935 33.0851 195.08 31.155Z",
    fill: "#89AAAD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_514",
    x1: 9.30078,
    y1: 24.2278,
    x2: 28.0567,
    y2: 32.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73314F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376449,
    stopColor: "#73314F",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB885A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_446_514",
    x1: 129.49,
    y1: 32.9695,
    x2: 143.861,
    y2: 36.3155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73314F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376449,
    stopColor: "#73314F",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB885A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87446"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin1);
export default __webpack_public_path__ + "static/media/coin1.fb68b007053d46eafdad21e4beed1e12.svg";
export { ForwardRef as ReactComponent };